<template>
    <div>
        <!-- 题目标签管理 弹窗：编辑标签组/创建标签组 -->
        <el-dialog v-if="groupDialogVisible" :title="form.tag_group_id?groupEditTextConfig.editTitle:groupEditTextConfig.addTitle"
                   :visible.sync="groupDialogVisible" width="500px" @close="close" destroy-on-close
                   :close-on-click-modal="false" :close-on-press-escape="false">
            <el-form :model="form" :rules="rules" ref="form" label-width="100px">
                <el-form-item :label="groupEditTextConfig.name" prop="tag_group_name">
                    <el-input v-model="form.tag_group_name" maxlength="30" show-word-limit clearable
                              :placeholder="groupEditTextConfig.nameTip"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="close">{{ groupEditTextConfig.cancel }}</el-button>
                <el-button type="primary" @click="submitForm('form')">{{ groupEditTextConfig.ok }}</el-button>
            </span>
        </el-dialog>
        <!-- 题目标签管理 弹窗：编辑标签/创建标签 -->
        <el-dialog v-if="tagDialogVisible" :title="form2.tag_id?tagEditTextConfig.editTitle:tagEditTextConfig.addTitle" :visible.sync="tagDialogVisible"
                   width="500px" @close="close" destroy-on-close :close-on-click-modal="false"
                   :close-on-press-escape="false">
            <el-form :model="form2" :rules="rules2" ref="form2" label-width="90px">
                <el-form-item :label="tagEditTextConfig.groupName">
                    <el-select v-model="form2.tag_group_id" clearable :placeholder="tagEditTextConfig.groupNameTip">
                        <el-option v-for="e in $parent.tagGroup" :key="e.id" :label="e.name" :value="e.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="form2.tag_id?tagEditTextConfig.name:tagEditTextConfig.addName" prop="textarea">
                    <el-input v-if="form2.tag_id" :placeholder="tagEditTextConfig.nameTip" maxlength="30"
                              show-word-limit v-model="form2.tag_name" clearable></el-input>
                    <el-input v-else type="textarea" :rows="5"
                              :placeholder="tagEditTextConfig.nameTip2"
                              v-model="form2.textarea"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="close">{{ tagEditTextConfig.cancel }}</el-button>
                <el-button type="primary" @click="submitForm2('form2')">{{ tagEditTextConfig.ok }}</el-button>
            </span>
        </el-dialog>
        <!-- 题目标签管理 弹窗：批量设置标签组 -->
        <el-dialog v-if="setGroupDialogVisible" :title="setScoreTextConfig.title" :visible.sync="setGroupDialogVisible"
                   width="500px" @close="close" destroy-on-close :close-on-click-modal="false"
                   :close-on-press-escape="false">
            <el-form :model="form3" ref="form3" label-width="90px">
                <el-form-item :label="setScoreTextConfig.group">
                    <el-select v-model="form3.tag_group_id" clearable :placeholder="setScoreTextConfig.groupTip">
                        <el-option v-for="e in $parent.tagGroup" :key="e.id" :label="e.name" :value="e.id"></el-option>
                    </el-select>
                    <p style="color:#C0C4CC">{{ setScoreTextConfig.groupText }}</p>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="close">{{ setScoreTextConfig.cancel }}</el-button>
                <el-button type="primary" @click="submitForm3('form3')">{{ setScoreTextConfig.ok }}</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    props: ['row', 'groupShow', 'tagShow', 'setShow', 'selectRow'],
    data() {
        return {
            groupDialogVisible: false,
            tagDialogVisible: false,
            setGroupDialogVisible: false,
            form: {
                tag_group_id: null,
                tag_group_name: '',
                // textarea: '',
                tag_name: ''
            },
            form2: {
                tag_id: null,
                tag_group_id: null,
                tag_name: '',
                textarea: ''
            },
            form3: {
                tag_group_id: null,
                tag_id: null
            },
            rules: {
                tag_group_name: [{
                    required: true,
                    message: this.$store.state.global.textConfig.backend.questionTag.tree.button.edit.group.nameRule,
                    trigger: 'change'
                }, {
                    validator: function (rule, value, callback) {
                        if (/^[\u4E00-\u9FA5A-Za-z0-9]+$/g.test(value) == false && value) {
                            callback(new Error("仅支持输入中英文、数字"));
                        } else {
                            callback();
                        }
                    },
                    trigger: "change"
                }]
            },
            rules2: {
                textarea: [{
                    required: true,
                    message: this.$store.state.global.textConfig.backend.questionTag.tree.button.edit.tag.nameRule,
                    trigger: 'change'
                }, {
                    validator: function (rule, value, callback) {
                        let snsArr = value.split(/[(\r\n)\r\n]+/), err = false
                        for (let i = 0; i < snsArr.length; i++) {
                            const item = snsArr[i];
                            if (/^[\u4E00-\u9FA5A-Za-z0-9]{1,30}$/g.test(item) == false && item) {
                                err = true
                            }
                        }
                        if (value) {
                            if (err) {
                                callback(new Error("仅支持输入中英文、数字，一行最多30字符"));
                            } else {
                                callback();
                            }
                        }
                    },
                    trigger: "change"
                }]
            },
        }
    },
    computed: {
        groupEditTextConfig() {
            return this.$store.state.global.textConfig.backend.questionTag.tree.button.edit.group
        },
        tagEditTextConfig() {
            return this.$store.state.global.textConfig.backend.questionTag.tree.button.edit.tag
        },
        setScoreTextConfig() {
            return this.$store.state.global.textConfig.backend.questionTag.batch.setGroup
        }
    },
    watch: {
        groupShow() {
            this.groupDialogVisible = this.groupShow;
        },
        tagShow() {
            this.tagDialogVisible = this.tagShow;
        },
        setShow() {
            this.setGroupDialogVisible = this.setShow
        },
        row() {
            if (this.row) {
                console.log(this.row);
                if (this.groupDialogVisible) {
                    this.form.tag_group_id = this.row.id
                    this.form.tag_group_name = this.row.name
                } else {
                    this.form2.tag_id = this.row.id
                    this.form2.tag_group_id = this.row.group_id == 0 ? null : this.row.group_id
                    this.form2.tag_name = this.row.name
                    this.form2.textarea = this.row.name
                }
            } else {
                this.form.tag_group_id = null
                this.form2.tag_id = null
            }
        },
        selectRow() {
            if (this.selectRow) {
                let ids = []
                for (let i = 0; i < this.selectRow.length; i++) {
                    const e = this.selectRow[i].id;
                    ids.push(e)
                }
                this.form3.tag_id = ids.join(',')
            }
        }
    },
    methods: {
        close() {
            this.form = {
                tag_group_id: null,
                tag_group_name: '',
                textarea: ''
            }
            this.form2 = {
                tag_id: null,
                textarea: '',
                tag_group_id: null,
                tag_name: ''
            }
            this.form3 = {
                tag_group_id: null,
                tag_id: null
            }
            this.groupDialogVisible = false
            this.tagDialogVisible = false
            this.setGroupDialogVisible = false
            this.$emit('close', false)
        },
        submitForm2(formName) {
            if (this.form2.tag_id) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.$store.dispatch("postQuestionTagValidation", this.form2.tag_name).then(res => {
                            if (res.status == 200) {
                                if (res.data.valid.length) {
                                    if (res.data.valid[0].id == this.form2.tag_id) {
                                        this.$store.dispatch("putQuestionTag", this.form2).then(res => {
                                            if (res.status == 200) {
                                                this.$message({
                                                    message: this.tagEditTextConfig.success,
                                                    type: 'success'
                                                });
                                                this.close()
                                            }
                                        });
                                    } else {
                                        this.$message({
                                            message: this.tagEditTextConfig.error.signMix(res.data.valid[0].name),
                                            type: 'error'
                                        });
                                    }

                                } else {
                                    this.$store.dispatch("putQuestionTag", this.form2).then(res => {
                                        if (res.status == 200) {
                                            this.$message({
                                                message: this.tagEditTextConfig.editSuccess,
                                                type: 'success'
                                            });
                                            this.close()
                                        }
                                    })
                                }
                            }
                        })
                    } else {
                        return false
                    }
                })
            } else {
                this.form2.tag_name = this.form2.textarea.split("\n").join(",")
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.$store.dispatch("postQuestionTagValidation", this.form2.tag_name).then(res => {
                            if (res.status == 200) {
                                if (res.data.valid.length) {
                                    let validArr = []
                                    for (let i = 0; i < res.data.valid.length; i++) {
                                        const e = res.data.valid[i];
                                        validArr.push(e.name)
                                    }
                                    this.$message({
                                        message: this.tagEditTextConfig.error2.signMix(validArr.length, validArr.join('、')),
                                        type: 'error'
                                    })
                                } else {
                                    this.$store.dispatch("postQuestionTag", this.form2).then(res => {
                                        if (res.status == 200) {
                                            this.$message({
                                                message: this.tagEditTextConfig.addSuccess,
                                                type: 'success'
                                            })
                                            this.close()
                                        }
                                    })
                                }
                            }
                        })
                    } else {
                        return false
                    }
                })
            }
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if (this.form.tag_group_id) {
                        this.$store.dispatch("putQuestionTagGroup", this.form).then(res => {
                            if (res.status == 200) {
                                this.$message({
                                    message: this.groupEditTextConfig.editSuccess,
                                    type: 'success'
                                });
                                this.close()
                            }
                        });
                    } else {
                        // this.form.tag_name = this.form.textarea.split("\n").join(",")
                        this.$store.dispatch("postQuestionTagGroup", this.form).then(res => {
                            if (res.status == 200) {
                                this.$message({
                                    message: this.groupEditTextConfig.addSuccess,
                                    type: 'success'
                                });
                                this.close()
                            }
                        });
                    }
                } else {
                    return false;
                }
            });
        },
        submitForm3(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.$store.dispatch("batchPutQuestionTagGroup", this.form3).then(res => {
                        if (res.status == 200) {
                            this.$message({
                                message: this.setScoreTextConfig.success,
                                type: 'success'
                            });
                            this.close()
                        }
                    });
                } else {
                    return false;
                }
            })
        }
    }
}
</script>

<style>

</style>
